<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="openAddDialog">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.recommend_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              plain
              @click="handlerEdit(scope)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      :title="dialogType==0? '新增': '编辑'"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="500px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.recommend_title"/>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input v-model="editObject.recommend_english_title"/>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="editObject.recommend_son_title"/>
        </el-form-item>
        <el-form-item label="英文副标题">
          <el-input v-model="editObject.recommend_english_son_title"/>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="editObject.recommend_url"/>
        </el-form-item>
        <el-form-item label="权重">
          <el-input-number
            v-model="editObject.recommend_sort"
            :min="1" />
            <!-- <el-input v-model="editObject.recommend_sort"/> -->
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.recommend_img"
              :src="qiniuDomain + editObject.recommend_img"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  recommendList, addRecommend, editRecommend, delRecommend,
} from '@/api/home-recommend'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        recommend_title: '',
        recommend_english_title: '',
        recommend_url: '',
        recommend_img: '',
        recommend_sort: '',
        recommend_son_title: '',
        recommend_english_son_title: '',
        uuid: '',
      },
      config: {
        pagination: false,
        size: 999,
        fields: [
          {
            prop: 'recommend_title',
            label: '标题',
          },
          {
            prop: 'recommend_son_title',
            label: '副标题',
          },
          {
            prop: 'recommend_english_title',
            label: '英文标题',
          },
          {
            prop: 'recommend_english_son_title',
            label: '英文副标题',
          },
          {
            prop: 'recommend_url',
            label: '跳转链接',
          },
          {
            prop: 'recommend_sort',
            label: '权重',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().recommendList()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().recommendList()
    },
    handlerEdit(data) {
      this.dialogType = 1 // 编辑框
      this.editObject.recommend_title = data.row.recommend_title
      this.editObject.recommend_son_title = data.row.recommend_son_title
      this.editObject.recommend_english_title = data.row.recommend_english_title
      this.editObject.recommend_english_son_title = data.row.recommend_english_son_title
      this.editObject.recommend_url = data.row.recommend_url
      this.editObject.recommend_sort = data.row.recommend_sort
      this.editObject.recommend_img = data.row.recommend_img
      this.editObject.uuid = data.row.uuid
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delRecommend(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.recommend_title = ''
      this.editObject.recommend_son_title = ''
      this.editObject.recommend_english_title = ''
      this.editObject.recommend_english_son_title = ''
      this.editObject.recommend_url = ''
      this.editObject.recommend_sort = ''
      this.editObject.recommend_img = ''
      this.editObject.uuid = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.recommend_img = res.hash
    },
    event() {
      return {
        onSaveClick: () => {
          if (!this.event().inputVerify()) return
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addRecommend()
          } else {
            this.network().editRecommend()
          }
        },
        inputVerify: () => {
          if (!this.editObject.recommend_title) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.recommend_son_title) {
            this.$message('请填写副标题')
            return false
          }
          if (!this.editObject.recommend_english_title) {
            this.$message('请填写英文标题')
            return false
          }
          if (!this.editObject.recommend_english_son_title) {
            this.$message('请填写英文副标题')
            return false
          }
          // eslint-disable-next-line
          const httpReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
          if (this.editObject.recommend_url && !httpReg.test(this.editObject.recommend_url)) {
            this.$message('跳转链接格式不正确')
            return false
          }
          if (!this.editObject.recommend_sort) {
            this.$message('请填写权重')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        recommendList: async () => {
          const { status, data } = await recommendList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addRecommend: async () => {
          const { status } = await addRecommend(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().recommendList()
          }
        },
        editRecommend: async () => {
          const { status } = await editRecommend(this.editObject)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
            this.dialogEdit = false
            this.network().recommendList()
          }
        },
        delRecommend: async (uuid) => {
          const { status } = await delRecommend({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().recommendList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/home/list.vue